import styled from 'styled-components';

export const StyledTopPanel = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 10px;
`;

export const StyledSankeyWrapper = styled.div`
  width: 50%;

  :first-child {
    border-right: 1px solid #e8e8e8;
  }
`;

export const StyledLineWrapper = styled.div`
  width: 50%;
`;
